// extracted by mini-css-extract-plugin
export var form = "ContactForm-module--form--ns57n";
export var form__group = "ContactForm-module--form__group--BKV6h";
export var form__label = "ContactForm-module--form__label--3gcYh";
export var form__input = "ContactForm-module--form__input--3SIcl";
export var form__textarea = "ContactForm-module--form__textarea--pYIuQ";
export var form__footer = "ContactForm-module--form__footer--ZVVmD";
export var form__submit = "ContactForm-module--form__submit--35kXX";